module.exports = __webpack_public_path__ + "static/btn01-1ffcfa177a4a49e0294c05b04bf8320f.png";